export default __webpack_public_path__ + "static/media/infernal_1.f240f151.png";